"use client";

import { useState } from "react";
import Form from "next/form";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import DialogAlert from "./UserToolbar/DialogAlert";
import SubmitButton from "./UserToolbar/SubmitButton";
import { createUserAction } from "./actions";

export default function CreateUserButton({ roles }: { roles: string[] }) {
  const [open, setOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
    setAlertVisible(false);
  };
  const handleClose = () => {
    setOpen(false);
    setAlertVisible(false);
  };

  const handleAction = async (formData: FormData) => {
    const result = await createUserAction(formData);
    if (result.success) {
      handleClose();
    } else {
      setAlertVisible(true);
    }
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Create User
      </Button>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <DialogAlert
          message="There was a problem creating the user"
          setVisible={setAlertVisible}
          visible={alertVisible}
        />
        <DialogTitle>Create New User</DialogTitle>
        <Form action={handleAction}>
          <DialogContent>
            <TextField
              className="mb-5"
              fullWidth
              label="Email"
              name="email"
              margin="dense"
              required
              type="email"
              variant="outlined"
            />
            <br />
            <div style={{ fontWeight: 500 }}>Assigned Roles</div>
            <FormGroup>
              {roles.map((role) => (
                <FormControlLabel
                  key={role}
                  control={<Checkbox name="roles" value={role} />}
                  label={role}
                />
              ))}
            </FormGroup>
            <div className="mt-5" style={{ fontWeight: 500 }}>
              Notifications
            </div>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="requires_account_summary_notifications"
                    value="true"
                  />
                }
                label="Account"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="requires_signals_notifications"
                    value="true"
                  />
                }
                label="Signals"
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <SubmitButton label="Create" pendingLabel="Creating..." />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
